import * as React from 'react';

import { createService } from '../../utils';
import { Icon } from './components/Icon';

export const PremiumService = createService({
  title: 'Премиум',
  subTitle: 'До х3 звонков',
  description: ['Больше просмотров', 'Фото и яркий заголовок', 'Выше Стандартных'],
  dataName: 'PremiumService',
  bgColor: 'white',
  icon: <Icon />,
});
